export default from './AnnualGrossIncomeQuestion';



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/AnnualGrossIncomeQuestion/index.js